import { createReduxUtil } from 'modules/redux/utils/legacy/create'
import { TOKEN_MODEL_CLASS_NAME, TOKEN_MODEL_KEY } from 'models/daos/token/constants'
import { TOKENS_PATH } from 'modules/tokens/constants'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'

/**
 * Gets the token's path using the given value.
 * @param  {string} value
 * @returns {string}
 */
function getPath (value) {
  return `${TOKENS_PATH.DATA}.${value}`
}

/**
 * Creates a token with the given value.
 * @param  {string} value
 * @returns {Function}
 */
function createTokenAction (value) {
  return dispatch => {
    // Add the token to the DomainMap
    dispatch(
      updateLegacyReduxAction({
        path: getPath(value),
        value: createReduxUtil(TOKEN_MODEL_CLASS_NAME, {
          data: {
            [TOKEN_MODEL_KEY.VALUE]: value
          }
        })
      })
    )
    // Add the token to the DomainNew
    dispatch(
      updateLegacyReduxAction({
        path: TOKENS_PATH.NEW,
        value
      })
    )
  }
}

export {
  createTokenAction
}
